import React from 'react';
import styled from 'styled-components';

import useCallbackRef from 'hooks/useCallbackRef';
import useFocusSearchInput from 'hooks/search/useFocusSearchInput';
import useSearchInputFocusCheck from 'hooks/search/useSearchInputFocusCheck';
import useSearchKeydown from 'hooks/search/useSearchKeydown';
import useModal from 'hooks/useModal';
import RecommendBox from './RecommendBox';
import useCommonStore from 'store/useCommonStore';
import CoreModal from 'shared/CoreModal';
import CoreSearchInput from 'shared/input/CoreSearchInput';
import { useNavigate } from 'react-router-dom';

const SearchInputModal = () => {
	// router
	const navigate = useNavigate();

	// store
	const { modal_position, setSearchModal, keyword, setKeyword } = useCommonStore();

	// ref
	const [search_dom, search_ref] = useCallbackRef();

	// hooks
	const [_, resetModalPosition] = useModal(setSearchModal);
	useFocusSearchInput(search_dom);
	const searchChange = useSearchKeydown(search_dom);
	const [focus] = useSearchInputFocusCheck(search_dom);

	/** 닫기 아이콘 클릭 시 */
	const closeSearchModal = () => {
		resetModalPosition();
		setKeyword('');
		navigate(`/imms/search?keyword=${''}`, { replace: true });
	};

	return (
		<CoreModal
			modal_type="common"
			top={modal_position.top ?? 0}
			left={modal_position.left ?? 0}
			setModal={resetModalPosition}
			x={'-50%'}
		>
			<ModalInner>
				<CoreSearchInput
					input_id="total-search-input"
					_ref={search_ref}
					_value={keyword}
					_onChange={searchChange}
					focus={focus}
					_onClickButton={closeSearchModal}
				/>

				{/* 추천 검색어 목록 */}
				<RecommendBox />
			</ModalInner>
		</CoreModal>
	);
};

const ModalInner = styled.div`
	width: 672px;
	padding: 15px 16px 16px 16px;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
`;

export default SearchInputModal;
